'use client';
import { Rocket, LogIn } from 'lucide-react';
import styles from './CtaFinal.module.css';
import { ScrollAnimator } from '@/components/ScrollAnimator';

export function CtaFinal() {
  return (
    <section className={styles.ctaSection}>
      <div className={styles.glow}></div>
      
      <ScrollAnimator>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className={styles.badge}>
            <Rocket size={16} /> Comece Hoje
          </div>
          
          <h2 className={styles.title}>
            Pronto para <span>escalar suas vendas?</span>
          </h2>
          
          <p className={styles.subtitle}>
            Junte-se a dezenas de empresas que transformaram o WhatsApp e o Instagram nos seus maiores canais de receita automática.
          </p>
          
          <div className={styles.buttonGroup}>
            <a href="https://api.whatsapp.com/send/?phone=5511983493522" className={styles.btnPrimary}>
              <Rocket size={20} />
              Criar conta grátis
            </a>
            <a href="https://aesirerp.com" target="_blank" className={styles.btnSecondary}>
              <LogIn size={20} />
              Já tenho conta
            </a>
          </div>
          
          <div className={styles.footerNote}>
            Sem fidelidade • Ative todos os módulos em menos de 5 minutos
          </div>
        </div>
      </ScrollAnimator>
    </section>
  );
}